


















































import { Component, Vue } from 'vue-property-decorator'
import { QueryCurrentShop, SubmitShopAuditStatus, UpdateShopStatus,QueryCurrentShopRegistMerchant,QueryShopRegistMerchantListById } from '@/api'
import { ShopAuditStatusFormat, ShopStatusFormat } from '@/utils/tyepconvert'
import EditShopDialogForShop from './EditShopDialogForShop.vue'
import EditBaseShopDialog from './components/EditBaseShopDialog.vue'
import { MessageBox } from 'element-ui'
import MerchantOpenCardForShop from './components/MerchantOpenCardForShop.vue'


@Component({
  components: {
    EditShopDialogForShop,
    EditBaseShopDialog,
    MerchantOpenCardForShop
  },
})
export default class ShopManage extends Vue {

  private data = { id:0,auditStatus: 3, auditStatusName: '' ,status:0}

  private get auditStatusTag(){
    switch(this.data.auditStatus){
      case 1:
        return '标签四'
      case 2:
        return 'success'
      case 3:
        return 'danger'
      default:
        return ''
    }
  }

  private get statusTag(){
    switch(this.data.status){
      case 0:
        return 'danger'
      case 1:
        return 'success'
      default:
        return ''
    }
  }

  public created() {
    this.loadShop()
    
  }

  private openMerchantList:any[] =[]

  // 加载商户
  private loadMerchant(){
    QueryShopRegistMerchantListById({id:this.data.id}).then((res:any)=>{
      const d = res
      if(d.filter((e:any)=>e.payChannel == 'huifu').length <= 0){
        d.push({
          payChannel: "huifu",
          payChannelName: "汇付支付",
          applicationStatus: "WAIT"
        })
      } 
      if(d.filter((e:any)=>e.payChannel == 'llpay').length <= 0){
         d.push({
          payChannel: "llpay",
          payChannelName: "连连支付",
          applicationStatus: "WAIT"
        })
      }
      this.openMerchantList = d
    })
  }

  // 加载当前用户的商店信息
  private async loadShop() {
    const result = await QueryCurrentShop()
    result.auditStatusName = ShopAuditStatusFormat(result.auditStatus)
    result.statusName = ShopStatusFormat(result.status)
    this.data = result
    // 加载开户情况
    this.loadMerchant()
  }
  private openEdit(){
    const p = this.$refs.EditShopDialogForShop as EditShopDialogForShop
    p.open(this.data,true)
  }
  private openBaseEdit(){
    const p = this.$refs.EditBaseShopDialog as EditBaseShopDialog
    p.open(this.data,true)
  }
  // 提交审核
  private submitAudit(){
    MessageBox.confirm('是否确定要提交审核？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await SubmitShopAuditStatus({ id: this.data.id })
      if (ruslt) {
        this.$message.success('提交成功')
        this.loadShop()
      }
    })
  }
  private async updateOpenStatus() {
    await UpdateShopStatus({
      id: this.data.id,
      status: 1,
    })
    this.loadShop()
  }
  private async updateCloseStatus() {
    await UpdateShopStatus({
      id: this.data.id,
      status: 0,
    })
    this.loadShop()
  }

  // 签署协议，获取协议连接，并跳转
  private xieyiHander(){
    QueryCurrentShopRegistMerchant({}).then(res=>{
      if(res.agreementSignurl){
        window.open(res.agreementSignurl, '_blank')
      } else {
        this.$message.warning("签署协议获取失败")
      }
    })
  }
}
